import { render, staticRenderFns } from "./CmsHeading.vue?vue&type=template&id=e9c5e964&scoped=true"
import script from "./CmsHeading.vue?vue&type=script&lang=js"
export * from "./CmsHeading.vue?vue&type=script&lang=js"
import style0 from "./CmsHeading.vue?vue&type=style&index=0&id=e9c5e964&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9c5e964",
  null
  
)

export default component.exports